import $ from 'jquery';
window.addEventListener('px-ready',function() {
    /*$(window).on('resize', function(){
        var h = $('.region1 .intro').outerHeight();
        $('.firstwest').css('height',h);
    }).trigger('resize')*/
});
